var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M77.06,38.56a2.06,2.06,0,1,0-2.92,2.92l6,6h-26v-26l6,6a2.07,2.07,0,1,0,2.92-2.93L52,13.5,41.06,24.44A2.07,2.07,0,1,0,44,27.37l6-5.95v26h-26l6-6a2.07,2.07,0,1,0-2.93-2.92L16,49.5,26.94,60.44a2,2,0,0,0,1.46.61,2.07,2.07,0,0,0,1.47-3.53l-6-6h26v26l-6-6a2.07,2.07,0,1,0-2.92,2.93L52,85.5,62.94,74.56A2.07,2.07,0,1,0,60,71.63l-6,6v-26h26l-6,6a2.06,2.06,0,0,0,0,2.92,2.05,2.05,0,0,0,2.92,0L88,49.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/Move.5460f2f182459715245a641cd3979c68.svg";
export { ForwardRef as ReactComponent };